import json_parse from './parse.js';
const JsonBigInt = {
}
JsonBigInt.install = function (Vue,options = {}) {
  Vue.prototype.$JsonBigInt = JsonBigInt;
}
JsonBigInt.parse = function(data){
   return json_parse()(data);
}
export default JsonBigInt
